import { SERVICES_REQUEST_PATH } from 'routes';
import { EditableServicesRequest, ServicesRequest } from 'store/ServicesRequest/types';

import { ServicesRequestStep } from './types';

export function generateServicesRequestStepPath({ step }: { step: ServicesRequestStep }) {
  return `${SERVICES_REQUEST_PATH}/${step}`;
}

export function isCreatableServicesRequest(
  servicesRequest: EditableServicesRequest
): servicesRequest is ServicesRequest {
  return !!(
    servicesRequest.services?.length &&
    servicesRequest.address &&
    servicesRequest.user?.firstname &&
    servicesRequest.user?.lastname &&
    servicesRequest.user?.email &&
    servicesRequest.user?.phone
  );
}
